const WHATSAPP_URL = "https://wa.me/5547999300330";

const areas = [
  {
    icon: "ri-government-line",
    title: "Direito Previdenciário",
    description:
      "Atuação na concessão e revisão de benefícios como aposentadorias, auxílios, pensões e benefícios assistenciais, assegurando mais segurança e dignidade ao cliente.",
    highlights: ["Aposentadoria por tempo de contribuição", "Benefício de Prestação Continuada (BPC)", "Revisão de benefícios negados", "Pensão por morte"],
  },
  {
    icon: "ri-briefcase-line",
    title: "Direito Trabalhista",
    description:
      "Defesa dos direitos de trabalhadores e empregadores em demandas como verbas trabalhistas, rescisões, indenizações, acordos e demais relações de trabalho.",
    highlights: ["Reclamações trabalhistas", "Rescisão de contrato", "Assédio moral e sexual", "Verbas rescisórias"],
  },
  {
    icon: "ri-bank-line",
    title: "Direito Bancário",
    description:
      "Atuação contra práticas abusivas de instituições financeiras, incluindo revisão de contratos, juros indevidos, negociação de dívidas e defesa em litígios.",
    highlights: ["Revisão de contratos de crédito", "Cobranças abusivas", "Negativação indevida", "Superendividamento"],
  },
  {
    icon: "ri-heart-2-line",
    title: "Direito de Família",
    description:
      "Atendimento em ações de divórcio, guarda, pensão alimentícia, inventário e regularização de vínculos familiares, com sensibilidade e responsabilidade.",
    highlights: ["Divórcio e separação", "Guarda e alimentos", "Inventário e herança", "União estável"],
  },
];

function AreaCard({ area }: { area: typeof areas[0] }) {
  return (
    <div
      className="group relative bg-white border border-gray-100 rounded-lg p-8 overflow-hidden cursor-pointer hover:border-[#E3B24A]/50 transition-all duration-300 h-full flex flex-col"
      style={{ boxShadow: "0 2px 20px rgba(139,15,20,0.06)" }}
    >
      {/* Background hover effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#8B0F14]/[0.02] to-[#E3B24A]/[0.04] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

      {/* Top accent line */}
      <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-[#8B0F14] to-[#E3B24A] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

      <div className="relative flex flex-col flex-1">
        {/* Icon */}
        <div
          className="w-14 h-14 flex items-center justify-center rounded-full border border-[#8B0F14]/15 mb-6 group-hover:bg-[#8B0F14] transition-colors duration-300"
          style={{ background: "rgba(139,15,20,0.06)" }}
        >
          <i className={`${area.icon} text-2xl text-[#8B0F14] group-hover:text-[#E3B24A] transition-colors duration-300`} />
        </div>

        {/* Title */}
        <h3 className="font-heading text-2xl font-semibold text-[#6E0C10] mb-3">
          {area.title}
        </h3>

        {/* Divider */}
        <div className="w-10 h-0.5 bg-[#E3B24A] mb-4" />

        {/* Description */}
        <p className="font-body text-gray-600 text-sm leading-relaxed mb-6">
          {area.description}
        </p>

        {/* Highlights */}
        <ul className="space-y-2 mb-8">
          {area.highlights.map((h) => (
            <li key={h} className="flex items-center gap-2 text-sm font-body text-gray-500">
              <div className="w-1.5 h-1.5 rounded-full bg-[#E3B24A] flex-shrink-0" />
              {h}
            </li>
          ))}
        </ul>

        {/* CTA */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-auto inline-flex items-center gap-2 text-[#8B0F14] font-body font-semibold text-sm border border-[#8B0F14]/30 hover:bg-[#8B0F14] hover:text-white hover:border-[#8B0F14] px-5 py-2.5 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-whatsapp-line" />
          Falar com um advogado
        </a>
      </div>
    </div>
  );
}

export default function AreasAtuacao() {
  return (
    <section id="areas" className="bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="mb-12">
          <div className="flex items-center gap-4 mb-4">
            <div className="h-px w-12 bg-[#C9992F]/60" />
            <span className="text-[#C9992F] font-body text-xs tracking-[0.3em] uppercase font-medium">
              Especialidades
            </span>
            <div className="h-px w-12 bg-[#C9992F]/60" />
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-semibold text-[#6E0C10] mb-3">
            Áreas de Atuação
          </h2>
          <p className="font-body text-gray-500 text-base max-w-xl leading-relaxed">
            Atuação jurídica especializada nas áreas que mais impactam a vida das pessoas, com compromisso, ética e excelência técnica.
          </p>
        </div>

        {/* Desktop grid — linear, 4 cols */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {areas.map((area) => (
            <AreaCard key={area.title} area={area} />
          ))}
        </div>

        {/* Mobile carousel — centered snap */}
        <div
          className="md:hidden flex overflow-x-auto pb-4"
          style={{
            scrollSnapType: "x mandatory",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            gap: "16px",
            paddingLeft: "calc(50vw - 140px)",
            paddingRight: "calc(50vw - 140px)",
          }}
        >
          {areas.map((area) => (
            <div
              key={area.title}
              className="flex-shrink-0"
              style={{
                scrollSnapAlign: "center",
                width: "280px",
              }}
            >
              <AreaCard area={area} />
            </div>
          ))}
        </div>

        {/* Scroll indicator dots — mobile */}
        <div className="flex justify-center gap-2 mt-6 md:hidden">
          {areas.map((area, i) => (
            <div
              key={area.title}
              className="w-1.5 h-1.5 rounded-full"
              style={{ background: i === 0 ? "#8B0F14" : "#8B0F1430" }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
